<!-- Figma 28583:58754: title, one paragraph, "Back to Library" and "Go to payment" side by side. -->
<div class="unlock">
  <h2 id="render-unlock-title" class="unlock__title">Unlock your pack</h2>
  <p class="unlock__text">Ready to bring your previews to life? Proceed to payment to start generating your high-quality videos. {{ fullEta }}.</p>
  <!-- [IMMEDIATE START CONSENT]: the order card's draft (RENDER_START_CONSENT), not yet confirmed by Alex. -->
  <label class="unlock__consent">
    <input type="checkbox" [checked]="startConsent" (change)="startConsent = $any($event.target).checked">
    <span>{{ startConsentText }}</span>
  </label>
  <div class="unlock__actions">
    <button class="unlock__back" type="button" (click)="onBack()">
      <svg width="12" height="12" viewBox="0 0 11.7625 11.3125" fill="none" aria-hidden="true"><path d="M1.00002 5.125L5.88127 1L10.7625 5.125" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
      Back to Library
    </button>
    <button class="rf-button unlock__pay" type="button" [disabled]="!startConsent" (click)="onPay()">Go to payment</button>
  </div>
  <p class="unlock__terms">By continuing, you agree to the <a [href]="termsUrl" target="_blank" rel="noopener">Terms</a> and the <a [href]="refundsUrl" target="_blank" rel="noopener">Refund Policy</a>.</p>
</div>
